<script setup>
import { computed, ref, toRefs } from "vue";
// import { parseISO } from "date-fns";
// import { format, utcToZonedTime } from "date-fns-tz";
import { formatDate } from "~/module/calendar";

const props = defineProps({
  project: {
    type: Object,
    required: true,
  },
  isPermitted: {
    type: Boolean,
    required: false,
    default: false,
  },
  address: {
    type: String,
    required: false,
    default: null,
  },
});

const { project, isPermitted, address } = toRefs(props);

const viewTab = ref("dates");

const emit = defineEmits(["gotoDate"]);

const showModal = ref(false);
const modalContent = ref();

const viewDocument = (doc) => {
  modalContent.value = doc;
  showModal.value = true;
};

// const getUtcDate = (unix_ts, show_from_date_only) => {
//   // Convert the start Unix timestamp to a JavaScript Date object in UTC timezone
//   const time = new Date(unix_ts); // Multiply by 1000 to convert to milliseconds
//   const parsedTime = parseISO(time.toISOString());
//   // const isoDate = startDate.toISOString()
//   // console.clear();
//   // console.log(parsedTime);
//   // Format the start date as "dd MMM yyyy HHmm UTC"
//   // const formattedDate = format(isoDate, "dd MMM yyyy HHmm 'UTC'");
//   let _fmt
//   if(show_from_date_only){
//     _fmt = "dd MMM yyyy 'UTC'"
//   }else{
//     _fmt = "dd MMM yyyy HHmm 'UTC'"
//   }
//   const formatInTimeZone = (date, fmt, tz) => format(utcToZonedTime(date, tz), fmt, { timeZone: tz });

//   const formattedTime = formatInTimeZone(parsedTime, _fmt , "UTC");

//   return formattedTime;
// };

const sortEvents = (_events) => {
  // console.log(_events);

  if (!_events) return [];

  if (_events[0]?.index) {
    // console.clear();
    // console.log(_events);

    let _events_sorted = _events.sort((a, b) => {
      return Number(a.index) - Number(b.index);
    });

    // console.log(_events_sorted);

    return _events_sorted;
  } else {
    _events = _events.sort((a, b) => {
      return b.from_unix - a.from_unix;
    });
    return _events;

    // sort by index, ascending
  }
};

// const isPermitted = () => {
//   if (address == "0x39E03e34Ca304D135D0e413B364B0dF65542c7B1") return true; // sigmud wallet address
//   if (accountStore?.accountData?.pspInfo) {
//     if (accountStore?.accountData?.pspInfo?.isOxbTier1 || accountStore?.accountData?.pspInfo?.isKwaiTier1 || accountStore?.accountData?.pspInfo?.oxbPsp?.isPsp || accountStore?.accountData?.pspInfo?.kwaiPsp?.isPsp) return true;
//     return false;
//   } else {
//     return false;
//   }
// };

const linkPermit = computed(() => {
  if (project.value.is_links_private) {
    if (isPermitted.value) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
});

const docsPermit = computed(() => {
  if (project.value.is_docs_private) {
    if (isPermitted.value) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
});

const canViewPinned = computed(() => {
  if (project.value.pinned_message) {
    if (project.value.is_pinned_private) {
      if (isPermitted.value) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  } else {
    return false;
  }
});

const replaceHyperlinks = (content) => {
  // console.clear();
  // console.log(content);

  if (!content) return;

  // [Medium](https://oxbull.medium.com/99a2834afb0b)

  // convert the Markdown link into <a> tag, with _blank target

  const regex = /\[(.*?)\]\((.*?)\)/g;

  const replaced = content.replace(regex, '<a href="$2" target="_blank">$1</a>');

  // console.log(replaced);

  return replaced;
};

const gotoDate = (_unix) => {
  emit("gotoDate", _unix);
}
</script>

<template>
  <div class="w-full unselectable">

    <div class="bg-woodsmoke-800/20 rounded-md p-4 hover:bg-woodsmoke-800/50 border border-woodsmoke-400/20 hover:border-woodsmoke-400 transition-all duration-200">
      <div class="w-full grid grid-cols-[50px_1fr] gap-4 justify-center items-center">
        <NuxtLink :to="`/app/project/${project.mongo_key}`">
          <div class="bg-white/5 w-[50px] h-[50px] rounded-xl overflow-hidden border border-woodsmoke-400 p-1 hover:scale-110 duration-100">
          <NuxtImg width="50" height="50" quality="80" :src="project.project_icon" class="w-full h-full object-cover rounded-lg" alt="" />
        </div>
        </NuxtLink>

        <div>
          <!-- <div v-if="project.is_private" class="text-xs uppercase text-woodsmoke-200 tracking-widest flex justify-start items-center">
            <span class="iconify text-turquoise-500 mr-1 -ml-1" data-icon="ic:sharp-star"></span>
            <p>exclusive</p>
          </div> -->
          <h1 class="font-semibold tracking-wider text-lg">{{ project.title }}</h1>

          <p class="text-sm text-woodsmoke-400">{{ project.subtitle }}</p>
        </div>

        <!-- <button class="btn btn-sm w-full h-full text-xs">open</button> -->
      </div>

      <div v-if="!isPermitted && (project.is_docs_private || project.is_links_private || project.is_pinned_private || project.is_private)" class="w-full py-4">
        <div class="bg-white/5 p-2 px-3 rounded-xl">
          <div class="w-full flex justify-start items-center space-x-2">
            <!-- <span class="iconify w-6 h-6 flex-shrink-0 text-woodsmoke-100" data-icon="mdi:eye"></span> -->
            <Icon name="mdi:eye" class="w-6 h-6 flex-shrink-0 text-woodsmoke-100" />

            <div v-if="!address">
              <p>Read more</p>
              <p class="text-xs text-woodsmoke-300">Connect a wallet with sufficient tier to unlock complete information</p>
            </div>

            <div v-if="address">
              <p>Insufficient Access</p>
              <p class="text-xs text-woodsmoke-300">Complete information available to Tier one of OXB and KWAI, and Private Sales Pass holders.</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="canViewPinned" class="bg-woodsmoke-700/50 rounded-md p-2 mt-4">
        <div class="inline-flex space-x-1 text-xs uppercase tracking-widest text-turquoise-500 font-bold justify-center items-center">
          <span class="iconify text-sm" data-icon="ic:baseline-push-pin"></span>
          <p>pinned</p>
        </div>

        <p class="text-sm text-woodsmoke-100">
          <MarkdownPreview :markdownString="project.pinned_message" ></MarkdownPreview>
        </p>
      </div>

      <div class="w-full gap-1 grid grid-cols-2 mt-4 text-xs uppercase tracking-widest text-woodsmoke-500 font-bold">
        <!-- <button class="w-full btn btn-sm">pinned</button> -->
        <button class="w-full btn btn-sm" :class="[viewTab == 'dates' ? 'bg-woodsmoke-700' : 'btn-ghost']" @click="viewTab = 'dates'">Dates</button>
        <button class="w-full btn btn-sm" :class="[viewTab == 'links' ? 'bg-woodsmoke-700' : 'btn-ghost']" @click="viewTab = 'links'">Links</button>
        <!-- <button  v-if="(project?.dates?.docs > 0)" class="w-full btn btn-sm" :class="[viewTab == 'docs' ? 'bg-woodsmoke-700' : 'btn-ghost']" @click="viewTab = 'docs'">docs</button> -->
      </div>

      <div class="w-full pt-4 px-1">
        <article v-if="viewTab == 'dates'" class="w-full mb-4 last:mb-0 divide-y divide-white/20">
          <div v-for="event in sortEvents(project?.dates)" class="w-full">
            <h3 class="font-semibold text-lg">{{ event.title }}</h3>
            <!-- <div class="flex justify-start items-center space-x-2">
                <div class="p-0.5 px-2 bg-turquoise-500 font-bold text-turquoise-900 rounded-md text-sm">{{  event.badge }}</div>
                <p class="text-sm">{{ event.slug }}</p>
            </div> -->
            <div class="flex justify-start items-center text-sm">
              <p @click="gotoDate(event.from_unix)" class="underline hover:text-turquoise-500">{{ formatDate(event.from_unix * 1000, event.from_format) }}</p>
              <p v-if="!event?.from_only" class="mx-3 text-turquoise-500 font-bold">TO</p>
              <p @click="gotoDate(event.to_unix)" v-if="!event?.from_only" class="underline hover:text-turquoise-500">{{ formatDate(event.to_unix * 1000, event.from_format) }}</p>
            </div>
          </div>

          <p v-if="!(project?.dates?.length > 0)" class="w-full text-center font-mono text-sm">-- No dates --</p>
        </article>

        <article v-if="viewTab == 'links'" class="">
          <template v-if="linkPermit">
            <!-- <markdown-preview>{{ replaceHyperlinks(project.link) }}</markdown-preview> -->
            <MarkdownPreview :markdownString="replaceHyperlinks(project.link)" ></MarkdownPreview>
            <p v-if="!project?.link" class="w-full text-center font-mono text-sm">-- No Links --</p>
          </template>
          <p v-else class="w-full text-center font-mono text-xs">
            <span v-if="address && !isPermitted">Complete information available to Tier one of OXB and KWAI, and Private Sales Pass holders.</span>
            <span v-else>Connect a wallet with sufficient tier to unlock complete information</span>
          </p>
        </article>

        <article v-if="viewTab == 'docs'">
          <template v-if="docsPermit">
            <p v-for="doc in project.docs" @click="viewDocument(doc)" class="underline btn btn-link p-0 text-turquoise-500 text-base capitalize">📄 {{ doc.title }}</p>
            <p v-if="!(project?.docs?.length > 0)" class="w-full text-center font-mono text-sm">-- No Documents --</p>
          </template>
          <p v-else class="w-full text-center font-mono text-xs">
            <span v-if="address && !isPermitted">Complete information available to Tier one of OXB and KWAI, and Private Sales Pass holders.</span>
            <span v-else>Connect a wallet with sufficient tier to unlock complete information</span>
          </p>
        </article>

        <!-- Open the modal using ID.showModal() method -->
        <!-- <button class="btn" onclick="my_modal_1.showModal()">open modal</button> -->
      </div>
    </div>

    <div class="modal" role="dialog" :class="showModal ? 'modal-open' : ''">
      <div class="modal-box p-2">
        <div class="w-full flex justify-between items-center bg-woodsmoke-600 p-4 rounded-xl mb-8">
          <h1 class="text-xl font-bold tracking-wider">{{ modalContent?.title }}</h1>
          <button class="btn btn-sm bg-turquoise-500 text-black border-transparent hover:text-white" @click="showModal = false">close</button>
        </div>

        <div class="w-full p-2 pb-8">
          <!-- <markdown-preview>{{ modalContent?.content }}</markdown-preview> -->
          <MarkdownPreview :markdownString="modalContent?.content" ></MarkdownPreview>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped >
.markdown-body {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  color: white !important;
}

.markdown-body ul {
  list-style-type: disc;
}

.markdown-body p {
  font-size: 0.8rem !important;
}

.markdown-body h1 {
  font-size: 1.5rem !important;
}

.markdown-body h2 {
  font-size: 1.4rem !important;
}

.markdown-body h3 {
  font-size: 1.3rem !important;
}

.markdown-body h4 {
  font-size: 1.2rem !important;
}

.markdown-body h5 {
  font-size: 1.1rem !important;
}

.markdown-body h6 {
  font-size: 1rem !important;
}
</style>
